import styled from "styled-components";
import {media} from "assets/css/media";

export const SectionTitle = styled.div`
	font-size: 18px;
	font-weight: 700;
	margin-bottom: 20px;

	@media (min-width: ${media.mobile}) {
		font-size: 24px;
	}
`;

export const SectionContent = styled.div``;
